import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zjbaakxhrprxtklmknua.supabase.co';
const supabaseAnonKey = 'sb_publishable_wJI1eQfBCqu-liTk7Sf9fA_uwQnSnuN';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
